// import {
//   AcceptInvitePage,
//   BillingPage,
//   CloneWorldPage,
//   DashboardPage,
//   HelpPage,
//   Login,
//   MyWorldsPage,
//   NewWorldPage,
//   PageNotFound,
//   Profile,
//   PurchaseTokensPage,
//   SearchWorldsPage,
//   SettingsPage,
//   Signup,
//   WorldBillingPage,
//   WorldPage,
//   WorldSettingsPage,
// } from "@dashboard-pages";
import { routeDefinition } from "./helpers";
import { AuthenticatedRouteGuard } from "./components";
import { UnauthenticatedRouteGuard } from "./components/UnauthenticatedRouteGuard";
import { lazy } from "react";
import { AdminRouteGuard } from "./components/AdminRouteGuard";

export const AppRoutes = {
  // ============================== Public Routes ==============================
  PageNotFound: routeDefinition({
    path: "*",
    url: () => "/",
    Component: lazy(() => import("../pages/PageNotFound/PageNotFound")),
  }),

  Login: routeDefinition({
    path: "/login",
    url: () => "/login",
    Component: lazy(() => import("../pages/Auth/Login")),
    Guard: UnauthenticatedRouteGuard,
  }),

  Signup: routeDefinition({
    path: "/signup",
    url: () => "/signup",
    Component: lazy(() => import("../pages/Auth/Signup")),
    Guard: UnauthenticatedRouteGuard,
  }),

  // AcceptInvite: routeDefinition({
  //   path: "/invite/:token",
  //   url: (params) => `/invite/${params.token}`,
  //   Component: (props) => <AcceptInvitePage token={props.params.token} />,
  // }),

  // =============================== Admin Routes ==============================

  AdminHome: routeDefinition({
    path: "/admin",
    url: () => "/admin",
    Component: lazy(() => import("../pages/Admin/AdminHome")),
    Guard: [AuthenticatedRouteGuard, AdminRouteGuard],
  }),

  AdminManageUsers: routeDefinition({
    path: "/admin/users",
    url: () => "/admin/users",
    Component: lazy(() => import("../pages/Admin/AdminManageUsers")),
    Guard: [AuthenticatedRouteGuard, AdminRouteGuard],
  }),

  AdminManageBaseWorlds: routeDefinition({
    path: "/admin/base-worlds",
    url: () => "/admin/base-worlds",
    Component: lazy(
      () => import("../pages/Admin/BaseWorlds/AdminManageBaseWorlds"),
    ),
    Guard: [AuthenticatedRouteGuard, AdminRouteGuard],
  }),

  AdminCreateBaseWorld: routeDefinition({
    path: "/admin/base-worlds/create",
    url: () => "/admin/base-worlds/create",
    Component: lazy(
      () => import("../pages/Admin/BaseWorlds/AdminCreateBaseWorld"),
    ),
    Guard: [AuthenticatedRouteGuard, AdminRouteGuard],
  }),

  AdminManageGameServerNodes: routeDefinition({
    path: "/admin/game-server-nodes",
    url: () => "/admin/game-server-nodes",
    Component: lazy(
      () => import("../pages/Admin/GameServerNodes/AdminManageGameServerNodes"),
    ),
    Guard: [AuthenticatedRouteGuard, AdminRouteGuard],
  }),

  AdminCreateGameServerNode: routeDefinition({
    path: "/admin/game-server-nodes/create",
    url: () => "/admin/game-server-nodes/create",
    Component: lazy(
      () => import("../pages/Admin/GameServerNodes/AdminCreateGameServerNode"),
    ),
    Guard: [AuthenticatedRouteGuard, AdminRouteGuard],
  }),

  AdminManageAssetServerNodes: routeDefinition({
    path: "/admin/asset-server-nodes",
    url: () => "/admin/asset-server-nodes",
    Component: lazy(
      () =>
        import("../pages/Admin/AssetServerNodes/AdminManageAssetServerNodes"),
    ),
    Guard: [AuthenticatedRouteGuard, AdminRouteGuard],
  }),

  AdminCreateAssetServerNode: routeDefinition({
    path: "/admin/asset-server-nodes/create",
    url: () => "/admin/asset-server-nodes/create",
    Component: lazy(
      () =>
        import("../pages/Admin/AssetServerNodes/AdminCreateAssetServerNode"),
    ),
    Guard: [AuthenticatedRouteGuard, AdminRouteGuard],
  }),

  // =========================== Authenticated Routes ==========================

  Dashboard: routeDefinition({
    path: "/",
    url: () => "/",
    Component: lazy(() => import("../pages/Dashboard/Dashboard")),
    Guard: AuthenticatedRouteGuard,
  }),

  Worlds: routeDefinition({
    path: "/worlds",
    url: () => "/worlds",
    Component: lazy(() => import("../pages/MyWorlds/MyWorldsPage")),
    Guard: AuthenticatedRouteGuard,
  }),

  NewWorld: routeDefinition({
    path: "/new-world",
    url: () => "/new-world",
    Component: lazy(() => import("../pages/NewWorld/NewWorldPage")),
    Guard: AuthenticatedRouteGuard,
  }),

  World: routeDefinition({
    path: "/worlds/:worldId",
    url: (params) => `/worlds/${params.worldId}`,
    Component: lazy(() => import("../pages/World/WorldPage")),
    Guard: AuthenticatedRouteGuard,
  }),

  Accounts: routeDefinition({
    path: "/accounts",
    url: () => "/accounts",
    Component: lazy(() => import("../pages/MyAccounts/MyAccountsPage")),
    Guard: AuthenticatedRouteGuard,
  }),

  // Profile: routeDefinition({
  //   path: "/profile",
  //   url: () => "/profile",
  //   Component: Profile,
  //   Guard: AuthenticatedRouteGuard,
  // }),

  // CloneWorld: routeDefinition({
  //   path: "/clone-world/:worldId",
  //   url: (params) => `/clone-world/${params.worldId}`,
  //   Component: (props) => <CloneWorldPage worldId={props.params.worldId} />,
  //   Guard: AuthenticatedRouteGuard,
  // }),

  // WorldSettings: routeDefinition({
  //   path: "/worlds/:worldId/settings",
  //   url: (params) => `/worlds/${params.worldId}/settings`,
  //   Component: (props) => <WorldSettingsPage worldId={props.params.worldId} />,
  //   Guard: AuthenticatedRouteGuard,
  // }),

  // Billing: routeDefinition({
  //   path: "/billing",
  //   url: () => "/billing",
  //   Component: lazy(() => import("../pages/Billing/BillingPage")),
  //   Guard: [
  //     createFeatureEnabledRouteGuard(Feature.billing),
  //     AuthenticatedRouteGuard,
  //   ],
  // }),

  // WorldBilling: routeDefinition({
  //   path: "/worlds/:worldId/billing",
  //   url: (params) => `/worlds/${params.worldId}/billing`,
  //   Component: (props) => <WorldBillingPage worldId={props.params.worldId} />,
  //   Guard: [
  //     createFeatureEnabledRouteGuard(Feature.billing),
  //     AuthenticatedRouteGuard,
  //   ],
  // }),

  // PurchaseTokens: routeDefinition({
  //   path: "/billing/purchase-tokens",
  //   url: () => "/billing/purchase-tokens",
  //   Component: PurchaseTokensPage,
  //   Guard: [
  //     createFeatureEnabledRouteGuard(Feature.billing),
  //     AuthenticatedRouteGuard,
  //   ],
  // }),

  // SearchWorlds: routeDefinition({
  //   path: "/search-worlds",
  //   url: () => "/search-worlds",
  //   Component: lazy(() => import("../pages/SearchWorlds/SearchWorldsPage")),
  //   Guard: [
  //     createFeatureEnabledRouteGuard(Feature.searchWorlds),
  //     AuthenticatedRouteGuard,
  //   ],
  // }),

  // Settings: routeDefinition({
  //   path: "/settings",
  //   url: () => "/settings",
  //   Component: SettingsPage,
  //   Guard: AuthenticatedRouteGuard,
  // }),

  Help: routeDefinition({
    path: "/help",
    url: () => "/help",
    Component: lazy(() => import("../pages/Help/Help")),
    Guard: AuthenticatedRouteGuard,
  }),
};
